import { useQuery } from '@tanstack/react-query';

import { Flex } from '@/components/base';
import Spinner from '@/components/Common/Spinner';
import Transition from '@/components/Common/Transition';
import Typo from '@/components/Typography/Typo';
import queryKeys from '@/configs/react-query-keys';
import service from '@/services/index';

import { DownloadButton } from '../../SearchContentStyles';
import KeySentimentDistribution from './KeySentimentDistribution';

type Props = {
  alias: string;
};

const KeySentimentDistributionContainer = (props: Props) => {
  const { data, isLoading } = useQuery({
    queryKey: [
      queryKeys.search.SEARCH_DETAIL,
      queryKeys.search.SEARCH_RESULT_FEEDBACK_SENTIMENT_DIST,
      props.alias,
    ],
    queryFn: () => {
      return service.globalSearch.fetchFeedbackSentimentDist(props.alias);
    },
  });

  return (
    <>
      <Flex j="space-between">
        <Flex a="center" g={12}>
          <Typo type="label0" weight="m">
            Key sentiment
          </Typo>
        </Flex>
        <DownloadButton />
      </Flex>
      <Transition status={!isLoading} fallback={<Spinner />}>
        {data && <KeySentimentDistribution data={data} />}
      </Transition>
    </>
  );
};

export default KeySentimentDistributionContainer;
